// Children layout routes
import HomeRoutes from './home_layout/home-layout-routes'
import APIDocumentationRoutes from './documentation/documentation-routes'
import AdminRoutes from './admin/admin-routes'
import MerchantRoutes from './merchant/merchant-routes'
// -------------------------------------------

const routes = [
  // HOME LAYOUT
  {
    path: '/',
    name: 'Home Layout',
    component: () => import('@/layout/HomeLayout.vue'),
    redirect: '/home',
    children: HomeRoutes
  },

  // DOCUMENTATION
  {
    path: '/',
    name: 'API Documentation Layout',
    component: () => import('@/layout/DocumentationLayout.vue'),
    redirect: '/api/get-started',
    children: APIDocumentationRoutes
  },

  // ADMIN
  {
    path: '/',
    name: 'Admin Layout',
    component: () => import('@/layout/DashboardLayout.vue'),
    children: AdminRoutes
  },

  // MERCHANT
  {
    path: '/',
    name: 'Merchant Layout',
    component: () => import('@/layout/DashboardLayout.vue'),
    children: MerchantRoutes
  },

  // NOT FOUND
  {
    path: '/:pathMatch(.*)*',
    name: 'Not Found',
    redirect: '/not-found',
    component: () => import('@/views/NotFound.vue')
  }
]

export default routes
